import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import P2 from '@base/P2/P2';
import P1 from '@base/P1/P1';
import { getUnLiveUrl } from '@api/selectors/urls';
import useGoalEventProps from '@hooks/useGoalEventProps';
import useCourseClassPlayer from '@hooks/useCourseClassPlayer';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import { addTime } from '@utils/dates';
import {
  PLANNER_CONTINUE_NUDGE_CLICKED,
  PLANNER_PAGE
} from '@constants/segment';
import { segment } from '@actions/analytics';
import { Spacings, Fonts } from '@styles/index';
import Slide from '@material-ui/core/Slide';
import useCheckFeatureLimit from '@cont/DeviceLimitation/useCheckFeatureLimit';
import useURLs from '@api/hooks/useURLs';
import { FeatureType } from 'types/features';
import useContinueWatchingData from './useContinueWatchingData';
import PlayIcon from '../PlannerCards/ClassCard/PlayIcon';

const Wrapper = styled.div`
  pointer-events: auto;
  position: absolute;
  width: 100%;
  max-width: 320px;
  bottom: ${Spacings.SPACING_12B};
  right: ${Spacings.SPACING_4B};
  padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_4B};
  border-radius: ${Spacings.SPACING_2B};
  box-shadow: ${boxShadowGenerator()};
  background: var(--color-base-1);
  display: grid;
  grid-template: repeat(2, max-content) / max-content 1fr;
  grid-column-gap: ${Spacings.SPACING_3B};
  grid-row-gap: ${Spacings.SPACING_1B};
  cursor: pointer;
`;

const Play = styled(PlayIcon)`
  grid-row: span 2;
`;

const Header = styled(P2)`
  line-height: 133%;
`;

const ClassTitle = styled(P1)`
  font-weight: ${Fonts.SEMIBOLD};
`;

const ContinueWatchingSection = () => {
  const data = useContinueWatchingData();
  const {
    query: { goalUID }
  } = useRouter();
  const unLiveURL = useURLs(getUnLiveUrl);
  const goalSegmentData = useGoalEventProps({ goalUID });

  const { open: openClassPlayer } = useCourseClassPlayer();

  const handleClassItemClick = useCheckFeatureLimit(FeatureType.CLASS, () => {
    if (data) {
      const item = {
        ...data,
        finishedAt:
          data.finishedAt ||
          addTime(new Date(data.liveAt), data.videoDuration, 's').getTime(),
        type: 1
      };

      openClassPlayer({
        lesson: item,
        course: { unLiveUrl: unLiveURL, goalUID },
        byPassCheck: true
      });
    }
  });

  if (!data) return null;
  const onClick = () => {
    segment.track(PLANNER_CONTINUE_NUDGE_CLICKED, {
      ...goalSegmentData,
      last_primary_source: PLANNER_PAGE,
      last_primary_source_section: 'Planner',
      index: 0,
      type: 'class'
    });
    handleClassItemClick();
  };
  return (
    <Slide direction="up" mountOnEnter unmountOnExit in>
      <Wrapper onClick={onClick}>
        <Play color="var(--color-i-blue-12)" />
        <Header color="var(--color-text-secondary)">Continue watching</Header>
        <ClassTitle lineClamp={1}>{data.name}</ClassTitle>
      </Wrapper>
    </Slide>
  );
};

export default ContinueWatchingSection;
